import "./SiteLogo.css";
import { Link } from "react-router-dom";
import logo, {
  ReactComponent as LogoSvg,
} from "../../assets/logo/by-thangcao-white.svg";

/*
 * The white "by thangcao" logo with its soft pulsing glow. On hover the glow
 * brightens and the handwritten "by" redraws itself (the logo is drawn inline
 * so its "by" shape, class "logo-by", can be animated).
 * - `to`: links to a page (song pages link to "/")
 * - `onClick`: acts as a button instead (home page scrolls to the top)
 */
function SiteLogo({ to, onClick, label = "thangcao home", className = "" }) {
  const content = (
    <>
      {/* Blurred copy behind the logo; only its opacity animates (smooth on Safari) */}
      <img className="site-logo-halo" src={logo} alt="" aria-hidden="true" />
      <LogoSvg className="site-logo" role="img" aria-label="by thangcao" />
    </>
  );

  return to ? (
    <Link to={to} className={`site-logo-link ${className}`} aria-label={label}>
      {content}
    </Link>
  ) : (
    <button
      type="button"
      onClick={onClick}
      className={`site-logo-link ${className}`}
      aria-label={label}
    >
      {content}
    </button>
  );
}

export default SiteLogo;
